import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import {
  setActivityPanelActiveTab,
  setProgressCardTitle,
  setShowActivityPanel
} from '../../store/actions/deepResearchActions';
import { useEffect, useState } from 'react';
import { IStore } from '../../store';

export const ProgressCard: React.FC<{ progress: number; handleAPIStop: () => void }> = ({
  progress,
  handleAPIStop
}) => {
  const dispatch = useDispatch();
  const progressCardTitle = useSelector((state: IStore) => state.deepResearch.progressCardTitle);
  const focusedMessage = useSelector((state: IStore) => state.deepResearch.focusedMessage);
  const [focusedMessageResponse, setFocusedMessageResponse] = useState<any>(null);
  const [progressHeading, setProgressHeading] = useState('');  

  useEffect(() => {
    let formattedResponse: any;
    try {
      formattedResponse = JSON.parse(focusedMessage?.response);
    } catch (e) {}
    setFocusedMessageResponse(formattedResponse);
  }, [focusedMessage]);

  useEffect(() => {
    setProgressHeading(progressCardTitle);
  }, [progressCardTitle]);

  const handleSourcesClick = () => {
    dispatch(setActivityPanelActiveTab('sources'));
    dispatch(setShowActivityPanel(true));
  };

  const [isStopped, setIsStopped] = useState(false);
  const handleStop = () => {
    dispatch(setProgressCardTitle('Stopped by user.'));
    setIsStopped(true);
    handleAPIStop();
  };

  return (
    <StyledProgressCard>
      <div className='deep-research-progress-bar-container'>
        <div className='deep-research-progress-bar-label'>
          {progressHeading}
          {focusedMessageResponse?.sources?.length > 0 && (
            <span className='deep-research-progress-bar-sources' onClick={handleSourcesClick}>
              {focusedMessageResponse?.sources?.length} sources
            </span>
          )}
        </div>
        <div className='deep-research-progress-bar-row'>
          <div className='deep-research-progress-bar'>
            <div className='deep-research-progress-bar-fill' style={{ width: `${progress}%` }} />
          </div>
          <button
            className='deep-research-progress-bar-stop'
            onClick={handleStop}
            disabled={isStopped}
            aria-label='Stop'>
            <span className='stop-square'></span>
          </button>
        </div>
      </div>
    </StyledProgressCard>
  );
};

const StyledProgressCard = styled.div`
  .deep-research-progress-bar-container {
    max-width: 420px;
    min-width: 220px;
    opacity: 1;
    gap: 4px;
    border-radius: 8px;
    padding: 16px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin: 0px 0px 2.5rem;
    background: #fff;
    border: 1px solid #dedee2;
    box-sizing: border-box;
    flex-wrap: wrap;
    overflow: hidden;
  }
  @media (max-width: 600px) {
    .deep-research-progress-bar-container {
      max-width: 98vw;
      min-width: 0;
      margin-left: 2vw;
      margin-right: 2vw;
    }
  }
  .deep-research-progress-bar-label {
    font-family: 'EYInterstate';
    font-weight: 400;
    font-style: normal;
    font-size: 12px;
    line-height: 20px;
    letter-spacing: 0;
    color: #1a1a24;
    vertical-align: middle;
    margin-bottom: 6px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    width: 100%;
    gap: 12px;
    flex-wrap: wrap;
    word-break: break-word;
    overflow-wrap: anywhere;
  }
  .deep-research-progress-bar-sources {
    color: #0f69ae;
    font-family: 'EYInterstate';
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    letter-spacing: 0;
    cursor: pointer;
  }
  .deep-research-progress-bar-row {
    display: flex;
    align-items: center;
    width: 100%;
    gap: 16px;
    flex-wrap: wrap;
    min-width: 0;
  }
  .deep-research-progress-bar {
    flex: 1 1 0;
    min-width: 0;
    height: 6px;
    background: #c3c3cb;
    border-radius: 20px;
    overflow: hidden;
    margin-bottom: 0;
    position: relative;
  }
  @media (max-width: 600px) {
    .deep-research-progress-bar-container {
      padding: 8px 4px;
      margin-left: 4px;
    }
    .deep-research-progress-bar-label {
      font-size: 11px;
      gap: 6px;
    }
    .deep-research-progress-bar-row {
      gap: 6px;
    }
  }
  .deep-research-progress-bar-fill {
    height: 100%;
    background: #1a1a24;
    border-radius: 20px;
    transition: width 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  }
  .deep-research-progress-bar-stop {
    margin: 0 0 0 8px;
    width: 21px;
    height: 21px;
    min-width: 21px;
    min-height: 21px;
    border: 1.5px solid #c3c3cb;
    border-radius: 50%;
    color: #c3c3cb;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
    transition:
      background 0.2s,
      color 0.2s;
    padding: 0;
    z-index: 2;
  }
  .deep-research-progress-bar-stop:disabled {
    background: #f3f3f3;
    color: #bbb;
    border-color: #ccc;
    cursor: not-allowed;
  }
  .stop-square {
    display: block;
    width: 10px;
    height: 10px;
    background: #1a1a24;
    border-radius: 2px;
  }
`;

export default ProgressCard;
